import { render, staticRenderFns } from "./ShippingProductAdditionalFeeCreate.vue?vue&type=template&id=02e43d45&scoped=true&"
import script from "./ShippingProductAdditionalFeeCreate.vue?vue&type=script&lang=js&"
export * from "./ShippingProductAdditionalFeeCreate.vue?vue&type=script&lang=js&"
import style0 from "./ShippingProductAdditionalFeeCreate.vue?vue&type=style&index=0&id=02e43d45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e43d45",
  null
  
)

export default component.exports